import type { TrendVerdict } from '../../api/types'
import { TOKENS } from '../ui/dashboard-primitives'

const ARROW: Record<string, string> = {
  up: 'M5 15l7-7 7 7', down: 'M19 9l-7 7-7-7', steady: 'M5 12h14',
}
export function TrendBadge({ verdict, label }: { verdict: TrendVerdict; label: string }) {
  const { direction, pct } = verdict
  const text = direction === 'steady' ? 'steady' : `${pct > 0 ? '+' : ''}${pct}%`
  const palette = direction === 'up'
    ? { color: '#cfe0b4', bg: 'rgba(159,174,143,.22)', border: 'rgba(179,201,140,.65)' }
    : direction === 'down'
    // eslint-disable-next-line no-restricted-syntax -- pre-existing color-literal drift, tracked in docs/refactor-suggestions.md Phase 0/2
    ? { color: '#f0a583', bg: 'rgba(198,110,77,.26)', border: 'rgba(214,122,86,.70)' }
    // eslint-disable-next-line no-restricted-syntax -- pre-existing color-literal drift, tracked in docs/refactor-suggestions.md Phase 0/2
    : { color: TOKENS.creamSoft, bg: TOKENS.creamBorder, border: 'rgba(245,237,225,.22)' }
  return (
    <span className="inline-flex items-center gap-[0.34rem] shrink-0 rounded-full font-mono font-semibold"
      style={{ fontSize: 11, padding: '.3em .65em', color: palette.color, background: palette.bg, border: `1px solid ${palette.border}`, whiteSpace: 'nowrap' }}
      title="vs 4-week average">
      <svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round"><path d={ARROW[direction]} /></svg>
      {text}<span style={{ color: TOKENS.creamDim, fontSize: 9, letterSpacing: '.12em', textTransform: 'uppercase', fontWeight: 500 }}>{label}</span>
    </span>
  )
}
